export default "__VITE_ASSET__BTeKdsgo__"